import { recommendationsPanelsLocaleKeys } from '@epicuro-next/constants/features/localization';

export const DEFAULT_ROOT_PROPERTIES = {
  hidePanelWhenItHasNoDataToShow: false,
  headerText: 'For You',
  noItemsIcon: ['fas', 'tag'],
  panelName: '',
  noItemsText: recommendationsPanelsLocaleKeys.itSeemsNoItemsHaveBeenOrderedYet,
  showUserNameInPanelTitle: false,
  showDeliveryDateLabel: false,
  showProductSizesPopover: false,
};
